<template>
  <div>
    <div v-html="data.message" class="n2br"></div>
  </div>
</template>

<script>
export default {
  naem: 'default-message',
  props: ['data'],
};
</script>
